import { shiftStartsOn, COPLINE_TIMEZONE } from "./timezone";

/**
 * How booked a Copline calendar day is, from the shifts that start on it:
 * - "empty"   — at least one of the day's shifts has nobody booked
 * - "full"    — every shift has the minimum number of volunteers
 * - "partial" — everything else
 *
 * A shift belongs to the day it starts on in Copline time (the same rule the
 * weekly grid uses), so the 16:00–24:00 shift counts toward its own day no
 * matter where the viewer's browser is.
 * @param {Array<{ effectiveDate: string|Date, shiftNumber: number }>} shifts
 * @param {string} day - "YYYY-MM-DD"
 * @param {string} [timeZone]
 * @returns {"empty"|"partial"|"full"}
 */
export const shiftsToDayBookingState = (
  shifts,
  day,
  timeZone = COPLINE_TIMEZONE
) => {
  // Shift structure history: 3 volunteers per shift before Dec 2020, and two
  // 12h shifts per day before Feb 2022.
  const minVolunteersPerShift = day < "2020-12-01" ? 3 : 2;
  const expectedShifts = day >= "2022-02-01" ? [1, 2, 3] : [1, 2];

  const volunteersPerShift = {};
  shifts
    .filter((shift) => shiftStartsOn(shift, day, timeZone))
    .forEach((shift) => {
      volunteersPerShift[shift.shiftNumber] =
        (volunteersPerShift[shift.shiftNumber] || 0) + 1;
    });

  if (expectedShifts.some((n) => !volunteersPerShift[n])) return "empty";
  if (expectedShifts.every((n) => volunteersPerShift[n] >= minVolunteersPerShift))
    return "full";
  return "partial";
};
